import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  CCloseButton,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
} from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import Logo from '@/assets/images/logo.png'
import { useGlobalSettings } from '@/hooks'
// sidebar nav config
import getNavItems from '@/_nav'



/**
 * @name AppSidebar
 * @description A sidebar component that includes a collapsible sidebar with a brand logo, navigation items, and a close button for mobile view. It controls the visibility of the sidebar and passes the navigation items to the AppSidebarNav component.
 * @param {boolean} sidebarShow - A boolean indicating whether the sidebar is visible or not.
 * @param {Function} setSidebarShow - A function to toggle the visibility of the sidebar.
 * @returns {JSX.Element} The rendered sidebar component with navigation and close button.
 */
const AppSidebar = ({ sidebarShow, setSidebarShow }) => {
  
  const { settings: globalSettings, isLoading: settingsLoading } = useGlobalSettings();
  const location = useLocation(); // Get current location from React Router

  // Get current path from React Router location (updates on route change)
  const currentPath = location?.pathname || '/dashboard';

  // Get navigation items (permissions feature removed - no permission filtering)
  const navigation = getNavItems(currentPath);
  
  return (
    <CSidebar
      className="border-end"
      colorScheme="light"
      position="fixed"
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        setSidebarShow(visible)
      }}
    >
      <CSidebarHeader className="border-bottom p-1 px-4">
        <CSidebarBrand to="/" className="d-flex align-items-center w-100" style={{ height: '100%', textDecoration: 'none', gap: '0.5rem' }}>
          <div style={{
            height: '34px',
          }}>
            <img
              src={globalSettings?.home_page_general_header_logo || Logo}
              alt={'header logo'}
              height={30}
              width={30}
              style={{ 
                width: 'auto', 
                height: 'inherit', 
                backgroundColor: 'transparent',
                border: 'none',
                outline: 'none',
                boxShadow: 'none'
              }}
            />
          </div>
          <span className={`fw-bold fs-5`}>Admin</span>
        </CSidebarBrand>
        <CCloseButton
          className="d-lg-none"
          onClick={() => setSidebarShow((prev) => !prev)}
        />
      </CSidebarHeader>
      <AppSidebarNav items={navigation} />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
